<template>
	<add-record
        :title="'Add Invoice'"
        :modalId="'add-invoice-modal'"
        :fields="soLineFields"
        :gridId="gridId"
        :onSuggestNameChange="onSuggestNameChange"
        :onSuggestNameSelect="onSuggestNameSelect"
        :getListOfNames="getListOfNames"
        :suggestionList="customersList"
        :resetModal="resetModal"
        :saveRecord="saveInvoice"
        :items="filteredSalesOrderLines"
        :contactsArr="contacts"
        :filterValObj="filterValObj"
        :isCompanyNameDefined="companyName != undefined"
        :showFilters="showFilters"
        :navigationField="'partNumber'"
        @updateCheckedRowItemIds="checkedSOLineItemIds = $event"
        class="mr-2" />
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import soLineFields from './fields';
import AddRecord from '@/shared/components/AddRecord';
import { CUSTOMER_ID, GRID_ID } from '@/shared/constants';

export default {
  name: 'Addinvoice',
  components: {
    AddRecord
  },
  props: {
    companyId: [Number, String],
    companyName: [String],
  },
  data: () => ({
    soLineFields,
    selectedAccount: {},
    filterValObj: {
        id: 0,
        companyId: 0,
        companyName: null,
        contactId: 0,
    },
    showFilters: {
        customer: true,
        contact: true
    },
    checkedSOLineItemIds: [],
    gridId: GRID_ID.INVOICE_ADD_GRID,
    customersList: []
  }),
  computed: {
    // ...mapGetters('quoteAdd', ['customers', 'contacts']),
    ...mapGetters('quoteAdd', ['contacts']),
    ...mapGetters('salesOrderLines', ['filteredSalesOrderLines']),
  },
  watch: {
    'filterValObj.contactId'(contactId) {
        this.checkedSOLineItemIds = [];
        this.filterLinesByContactId(contactId);
    }
  },
  methods:{
    /*...mapMutations('salesOrderLines', [ 'clearSalesOrderLinesByCompany', 'filterLinesByContactId' ]),*/
    ...mapMutations('salesOrderLines', [ 'setItem', 'filterLinesByContactId']),
    ...mapActions('companies', ['getByNameAndAccountType']),
    ...mapActions('salesOrderLines', [ 'getSalesOrderLinesByCompany' ]),
    // ...mapActions('quoteAdd', [ 'getCustomers', 'getContacts', 'clearContacts' ]),
    ...mapActions('quoteAdd', [ 'getCustomers', 'getContacts']),
    ...mapMutations('quoteAdd',{quoteAddSetItem: 'setItem'}),
    ...mapActions('invoices', ['addInvoiceWithMultipleSOLines']),
    async resetModal() {
        this.filterValObj.id = 0;
        this.filterValObj.companyId = 0;
        this.filterValObj.contactId = 0;
        /*this.clearSalesOrderLinesByCompany();*/
        this.setItem({ resource: 'salesOrderLinesByCompany', payload: [] });
        this.setItem({ resource: 'filteredSalesOrderLines', payload: [] });
        // this.clearContacts();
        this.quoteAddSetItem({ resource: 'contacts', payload: [] });
        this.checkedSOLineItemIds = [];
    },
    async onSuggestNameChange(val) {
        if (val === '') {
            this.resetModal();
        }
    },
    async onSuggestNameSelect(suggestion) {
        this.selectedAccount = suggestion;
        this.filterValObj.id = suggestion.id;
        this.filterValObj.companyId = suggestion.id;
        this.filterValObj.companyName = suggestion.name;
        this.getSalesOrderLinesByCompany(suggestion.id);
        this.getContacts(suggestion.id);
    },
    async getListOfNames(name) {
        this.customersList = await this.getByNameAndAccountType({
            typeId: CUSTOMER_ID, name});

        return this.customersList;
    },
    async resetModal() {
        if (!this.companyId && !this.companyName) {
            this.filterValObj.id = 0;
            this.filterValObj.companyId = 0;
            this.filterValObj.contactId = 0;
            // this.clearSalesOrderLinesByCompany();
            this.setItem({ resource: 'salesOrderLinesByCompany', payload: [] });
            this.setItem({ resource: 'filteredSalesOrderLines', payload: [] });
            // this.clearContacts();
            this.quoteAddSetItem({ resource: 'contacts', payload: [] });
        }
        this.checkedSOLineItemIds = [];
    },
    async saveInvoice() {
        if (this.filterValObj.companyId != null) {
            var invoiceData = await this.addInvoiceWithMultipleSOLines({
                invoiceId: 0,
                companyId: this.filterValObj.companyId,
                contactId: this.filterValObj.contactId,
                salesOrderLineIdList: this.checkedSOLineItemIds
            });

            if (invoiceData != null) {
                this.$snotify.success('Invoice Saved Successfully', 'Invoice');
                this.$router.push({
                    name: 'invoices.edit',
                    params: { id: invoiceData.id },
                });
            }
        }
    }
  },
  created() {
    if (this.companyId && this.companyName) {
      this.onSuggestNameSelect({
        id: parseInt(this.companyId),
        name: this.companyName
      });
    }
  }
};
</script>
